import { GetUserProfileDetailQuerySuccessResponseKeys } from '../../../services/IbUserAccountsServices/GraphQlService/types';

const allSuccessKeys: GetUserProfileDetailQuerySuccessResponseKeys[] = [
  'user_id',
  'name',
  'last_name',
  'phone_number',
  'country_code',
  'email',
  'profile_pic_url',
  'cover_page_url',
  'dob',
  'gender',
  'is_phone_number_verified',
  'is_phone_number_verified',
  'is_email_verified',
  'preferred_languages',
  'nationality',
  'family_income'
];
const getUserProfileDetailGraphQlQuery = (
  successKeys: GetUserProfileDetailQuerySuccessResponseKeys[],
  withQuery = true
): string => {
  const keysToUse = successKeys?.length ? successKeys : allSuccessKeys;

  const successFields = `success_response { ${keysToUse.join(' ')} }`;

  const failureFields = `failure_response { res_status response }`;

  if (withQuery) {
    return `
    query getUserProfileDetail{
      user_profile_details{
        ${successFields}
        ${failureFields}
      }
    }
  `;
  } else
    return `
    user_profile_details{
      ${successFields}
      ${failureFields}
    }
    `;
};

export { getUserProfileDetailGraphQlQuery };
